class pcas {
  constructor(pcaId, name, description) {
    this.pcaId = pcaId;
    this.name = name;
    this.description = description;
  }

  static fromJson({ pcaId, nombre, descripcion }) {
    return new pcas(pcaId, nombre, descripcion);
  }
}

export default pcas;
